import { CdkService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { useQuery } from 'react-query';

export type FindVehicleInput = {
  branchId: number;
  regNo: string;
};

export const useFindVehicleQuery = (input: FindVehicleInput, options?: { enabled?: boolean }) =>
  useQuery<Awaited<ReturnType<typeof CdkService.getCdkVehiclesVehicleFind>>, QueryError>(
    ['findVehicle', input.branchId, input.regNo],
    () => CdkService.getCdkVehiclesVehicleFind(input.branchId, input.regNo),
    {
      enabled: options?.enabled ?? false
    }
  );
